import * as R from 'ramda'
import { createSelector } from 'reselect'
import { entitySelector } from 'containers/Entity/selectors'
import {
  employeeImages,
} from 'containers/User/EmployeeImage/selectors'

const commentsStateSelector = state => state.project.greenlight.comments

const commentSelectorFunc = (entities, commentRefs, imageRefs) => {
  return commentRefs.map(id => {
    const { username, ...comment } = entities['comments'][id]
    const { image } = R.has(username)(imageRefs)
      ? imageRefs[username]
      : {}
    return { ...comment, username, image }
  })
}

const commentsSelector = createSelector(
  entitySelector,
  commentsStateSelector,
  employeeImages,
  commentSelectorFunc
)

const commentsUsernameSelector = createSelector(
  entitySelector,
  commentsStateSelector,
  (entities, commentRefs) => {
    const usernames = commentRefs.map(id => {
      const { username } = entities['comments'][id]
      return username
    })
    return [...new Set(usernames)]
  }
)

export {
  commentsSelector,
  commentsUsernameSelector
}
